import getListings from '@api/routes/listings-api/getNewsListings';
import * as templates from './templates';

var Bunge = Bunge || {};

Bunge.newsListings = (function($) {
    var ui = {};

    var searchParams = {
        pageNum: 1,
        searchTerm: '',
        pageSize: 18,
        searchtags: '',
        categories: '',
        regions: '',
        sites: '',
    };

    var locale = (navigator && navigator.language) || "en";

    const queryString = window.location.search;
    const urlParams1 = new URLSearchParams(queryString);
    if (urlParams1.has('regions')) {
    } else {
        let regionsType = $('[data-regions]').attr('data-regions');
        if (regionsType) {
            searchParams.regions = $('[data-regions]').attr('data-regions');
            let items = document.querySelectorAll('[name="byRegions"]');
            let value = searchParams.regions;

            let nameArr = value.split(',');
            nameArr.forEach(function(regionName) {
                items.forEach(function(item) {
                    if (item.value.toLowerCase() == regionName.toLowerCase()) {
                        item.checked = true;
                    }
                });
            });
            searchParams.regions = value;
        }
    }

    let sitesType = $('[data-sites]').attr('data-sites');
    if (sitesType) {
        searchParams.sites = $('[data-sites]').attr('data-sites');
    }

    function cacheUI() {
        ui.$yearFilter = $('select[data-control="filter-year"]');
        ui.$sitesFilter = $('select[data-control="filter-sites"]');
        ui.$categoriesFilter = $('select[data-control="filter-categories"]');
        ui.$newsListingRegon = $('[data-regon="newsListingResults"]');
        ui.$searchInput = $('[data-control="searchInput"]');
        ui.$clearInput = $('[data-control="clearsearch"]');
        ui.$searchSubmitBtn = $('[data-control="searchSubmit"]');
        ui.$searchWrapper = $('[data-regon="searchWrapper"]');
        ui.$totalResults = $('[data-regon="totalResults"]');
        ui.$resultsFor = $('[data-regon="resultsFor"]');
        ui.$resultInfo = $('[data-regon="resultinfo"]');
        ui.$pagination = $('[data-regon="pagination"]');
        ui.loader = $('[data-control="pageLoader"]');
        ui.totalpages = '';
        ui.totalResults = 0;
        ui.apiurl = ui.$newsListingRegon.data('apiurl');
    }

    function bindEvents() {
        ui.$searchSubmitBtn.on('click', searchClick);
        ui.$clearInput.on('click', clearInput);
        ui.$yearFilter.on('change', yearChanged);
        ui.$categoriesFilter.on('change', categoriesChanged);
        ui.$sitesFilter.on('change', sitesChanged);
        ui.$searchInput.on('keypress', function(e) {
            if (e.which == 13) {
                searchClick();
            }
        });
    }

    function init() {
        if ($('[data-regon="newsListingResults"]').length <= 0) {
            return;
        }
        cacheUI();
        bindEvents();
        showLoader();
        ui.$clearInput.hide();

        if (window.location.href.match(/\?./)) {
            const urlParams = new URLSearchParams(
                decodeURIComponent(window.location.search)
            );

            for (const [key, value] of urlParams.entries()) {
                if (key === 'filterYear' && value != '') {
                    let items = document.querySelectorAll(
                        '[name="filterYear"]'
                    );

                    items.forEach(function(item) {
                        if (item.value == value) {
                            item.checked = true;
                        } else {
                            item.checked = false;
                        }
                    });

                    searchParams.filterYear = value;
                }

                if (key === 'regions' && value != '') {
                    let items = document.querySelectorAll('[name="byRegions"]');

                    let nameArr = value.split(',');
                    nameArr.forEach(function(regionName) {
                        items.forEach(function(item) {
                            if (item.value == regionName) {
                                item.checked = true;
                            }
                        });
                    });
                    searchParams.regions = value;
                }

                if (key === 'categories' && value != '') {
                    let items = document.querySelectorAll(
                        '[name="byCategory"]'
                    );

                    let nameArr = value.split(',');
                    nameArr.forEach(function(catName) {
                        items.forEach(function(item) {
                            if (item.value == catName) {
                                item.checked = true;
                            }
                        });
                    });

                    searchParams.categories = value;
                }

                if (key === 'searchTerm' && value != '') {
                    ui.$searchInput.val(value);
                    ui.$clearInput.show();
                }
            }
        }
        if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                navigator.userAgent
            ) ||
            $(window).width() < 767
        ) {
            searchParams.pageSize = parseInt(
                $('div[data-pageSizeMobile]').attr('data-pageSizeMobile')
            );
        } else {
            searchParams.pageSize = parseInt(
                $('div[data-pageSize]').attr('data-pageSize')
            );
        }
        getNewsListings(false);
    }

    function updateResultInfo() {
        var info = '';
        if (searchParams.searchTerm !== '') {
            ui.$resultsFor.show();
            ui.$totalResults.hide();
            info += '&nbsp;' + searchParams.searchTerm;
        } else {
            ui.$totalResults.show();
            ui.$resultsFor.hide();
        }

        info += '&nbsp;' + ui.totalResults;
        ui.$resultInfo.html(info);
        ui.$resultInfo.show();
    }

    function searchClick() {
        showLoader();
        searchParams.searchTerm = ui.$searchInput.val();
        searchParams.pageNum = 1;
        getNewsListings(true);
    }
    function clearInput() {
        ui.$searchInput.val('');
        ui.$clearInput.hide();
    }

    function formatFilters(filters) {
        let filter = '';
        let index = 0;
        for (let [key, value] of Object.entries(filters)) {
            if (index >= 1) {
                filter += '|' + key + ':' + value;
            } else {
                filter += key + ':' + value;
            }
            index++;
        }
        return filter;
    }

    let listingResults = document.querySelector('.listing__results');
    let dataTags;
    if (listingResults) {
        dataTags = listingResults.getAttribute('data-tags');
        if (dataTags) {
            searchParams.searchtags = dataTags;
        }
    }

    function yearChanged() {
        showLoader();
        searchParams.filterYear = $(this).val();
        getNewsListings(true);
    }

    function sitesChanged() {
        showLoader();
        searchParams.regions = $(this).val();
        getNewsListings(true);
    }

    function categoriesChanged() {
        showLoader();
        searchParams.categories = $(this).val();
        getNewsListings(true);
    }

    function scrollToTop() {
        let articleCardButton = document.querySelector('.article-card__btn');
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });

        setTimeout(function() {
            articleCardButton = document.querySelector('.article-card__btn');
            articleCardButton.focus();
        }, 500);
    }

    function paginationClick(e) {
        let selectedPage = $(e.currentTarget).data('page');
        showLoader();
        searchParams.pageNum = parseInt(selectedPage);
        getNewsListings(true);
        scrollToTop();
    }

    function getDateFormat(dateStr) {
        const date = new Date(dateStr);
        const formattedDate = !isNaN(date) ? date.toLocaleDateString(locale) : '';
        return formattedDate;
    }

    async function getNewsListings(updateURL) {
        let url = ui.apiurl;
        if (process.env.NODE_ENV !== 'development') {
            getListings.setRoute(url);
        }
        const { success, data, error } = await getListings.query(searchParams);
        if (!success) {
            console.log('failed', error);
            hideLoader();
            return;
        }
        ui.totalpages = parseInt(data.totalPages);
        ui.totalResults = parseInt(data.totalResults);
        console.log(data);
        var newsCards = '';
        console.log(navigator);
        $.each(data.newsListings, function(i, item) {
            newsCards += `${templates.newsCard({
                title: item.title,
                category: item.category,
                date: getDateFormat(item.date),
                imgURL: item.image.url,
                altText: item.image.alt,
                url: item.linkURL,
                urlText: item.linkUrlText,
            })}`;
        });
        ui.$newsListingRegon.html(newsCards);
        updateResultInfo();
        updatePagination(searchParams.pageNum, ui.totalpages);
        if (updateURL) {
            updateURLHistory();
        }
        hideLoader();
    }

    function updateURLHistory() {
        if ('URLSearchParams' in window) {
            var newSearchParams = new URLSearchParams(window.location.search);
            if (searchParams.searchTerm !== '') {
                newSearchParams.set('searchTerm', searchParams.searchTerm);
            } else {
                newSearchParams.delete('searchTerm');
            }
            if (searchParams.filterYear !== '') {
                newSearchParams.set('filterYear', searchParams.filterYear);
            } else {
                newSearchParams.delete('filterYear');
            }
            if (searchParams.categories !== '') {
                newSearchParams.set('categories', searchParams.categories);
            } else {
                newSearchParams.delete('categories');
            }
            newSearchParams.set('pageNum', searchParams.pageNum);

            if (searchParams.regions !== '') {
                newSearchParams.set('regions', searchParams.regions);
            } else {
                newSearchParams.delete('regions');
            }
            var newRelativePathQuery =
                window.location.pathname + '?' + newSearchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
    }

    function newsListingFilterToggle(e) {
        let currentDropdown = e.currentTarget.nextElementSibling;
        if ($(currentDropdown).hasClass('-hidden')) {
            $('.listing__filter__dropdown__container').addClass('-hidden');
            $('.listing__filter__toggle-button').removeClass('active');
            $(currentDropdown).removeClass('-hidden');
            $(this).addClass('active');
        } else {
            $('.listing__filter__dropdown__container').addClass('-hidden');
            $('.listing__filter__toggle-button').removeClass('active');
        }
    }

    $('#-news-listing-search .listing__filter__toggle-button').on(
        'click',
        newsListingFilterToggle
    );

    function radioClick(e) {
        let currentDropdown = e.currentTarget;
        let name = currentDropdown.name;
        if (name == 'sortByDate') {
            searchParams.sortByDate = $(this).val();
        }

        if (name == 'byCategory') {
            let categoryItems = document.querySelectorAll(
                '[name="byCategory"]'
            );
            let categoryChoices = '';
            let choices = 0;
            categoryItems.forEach(function(item) {
                if (item.checked) {
                    choices++;
                    if (choices > 1) {
                        categoryChoices += ',';
                    }
                    categoryChoices += item.value;
                }
            });
            searchParams.categories = categoryChoices;
        }

        if (name == 'byRegions') {
            let siteItems = document.querySelectorAll('[name="byRegions"]');
            let siteChoices = '';
            let choices = 0;
            siteItems.forEach(function(item) {
                if (item.checked) {
                    choices++;
                    if (choices > 1) {
                        siteChoices += ',';
                    }
                    siteChoices += item.value;
                }
            });
            searchParams.regions = siteChoices;
        }

        if (name == 'filterYear') {
            searchParams.filterYear = $(this).val();
        }
        searchParams.pageNum = 1;
        getNewsListings();
        updateURLHistory();

        $(
            '-news-listing-search .listing__filter__toggle-button.active'
        ).click();

        $('.by-year').hide();
        $('.by-site').hide();
        $('.by-category').hide();
        $('.listing__filter__toggle-button.active').click();
        $('.listing__filter__dropdown__container .active-button').removeClass(
            'active-button'
        );
    }

    $('#-news-listing-search .listing__filter__dropdown__item input').on(
        'click',
        radioClick
    );

    function toggleYearMenu() {
        $('.by-year').toggle();
        $('.by-site').hide();
        $('.by-category').hide();
        if ($(this).hasClass('active-button')) {
            $('.active-button').removeClass('active-button');
        } else {
            $('.active-button').removeClass('active-button');
            $(this).addClass('active-button');
        }
    }

    $('#-news-listing-search .js-toggle-year-menu').on('click', toggleYearMenu);

    function toggleSiteMenu() {
        $('.by-site').toggle();
        $('.by-year').hide();
        $('.by-category').hide();
        if ($(this).hasClass('active-button')) {
            $('.active-button').removeClass('active-button');
        } else {
            $('.active-button').removeClass('active-button');
            $(this).addClass('active-button');
        }
    }

    $('#-news-listing-search .js-toggle-site-menu').on('click', toggleSiteMenu);

    function toggleCategoryMenu() {
        $('.by-category').toggle();
        $('.by-year').hide();
        $('.by-site').hide();
        if ($(this).hasClass('active-button')) {
            $('.active-button').removeClass('active-button');
        } else {
            $('.active-button').removeClass('active-button');
            $(this).addClass('active-button');
        }
    }

    $('#-news-listing-search .js-toggle-category-menu').on(
        'click',
        toggleCategoryMenu
    );

    function resetFilters() {
        $('.by-pdf').hide();
        $('.by-year').hide();
        $('.by-category').hide();
        $('.active-button').removeClass('active-button');
        searchParams.filterYear = '';
        searchParams.regions = '';
        searchParams.categories = '';
        searchParams.pageNum = 1;
        let sideMenuRb = document.querySelectorAll(
            '.listing__filter__dropdown__side-menu__buttons input'
        );
        sideMenuRb.forEach(function(item) {
            item.checked = false;
        });
        getNewsListings();
        updateURLHistory();
        $('.listing__filter__toggle-button.active').click();
    }

    $('#-news-listing-search .js-reset-filters').on('click', resetFilters);

    function updatePagination(page, totalPages) {
        let liTag = '';
        let active = '';
        page = parseInt(page);
        let beforePage = page - 1;
        let afterPage = page + 1;

        if (page > 1) {
            liTag += `<li class="page-item"><button data-page="${page -
                1}" class="page-link" aria-label="Previous"><span aria-hidden="true"></span></button></li>`;
        } else if (page == 1) {
            liTag += `<li class="page-item disabled"><button data-page="${page}" class="page-link" disabled="true" aria-label="Previous"><span aria-hidden="true"></span></button></li>`;
        }

        if (page > 2) {
            if (totalPages >= 5) {
                liTag += `<li class="page-item"><button data-page="1" class="page-link"><span>1</span></button></li>`;
            }
            if (page > 3 && totalPages > 5) {
                liTag += `<li class="page-item pagination-bar__dots dots"><span class="page-link">...</span></li>`;
            }
        }
        // how many pages or li show before the current li
        if (page == totalPages) {
            beforePage = beforePage - 2;
        } else if (page == totalPages - 1) {
            beforePage = beforePage - 1;
        }

        if (beforePage < 0) {
            beforePage = 0;
        }
        // how many pages or li show after the current li
        if (page == 1) {
            afterPage = afterPage + 2;
        } else if (page == 2) {
            afterPage = afterPage + 1;
        }
        for (let plength = beforePage; plength <= afterPage; plength++) {
            if (plength > totalPages) {
                //if plength is greater than totalPage length then continue
                continue;
            }
            if (plength == 0) {
                //if plength is 0 than add +1 in plength value
                plength = plength + 1;
            }
            if (page == plength) {
                //if page is equal to plength than assign active string in the active variable
                active = 'active';
            } else {
                //else leave empty to the active variable
                active = '';
            }
            liTag += `<li class="page-item numb ${active}"><button data-page="${plength}" class="page-link"><span>${plength}</span></button></li>`;
        }

        if (page < totalPages - 1) {
            //if page value is less than totalPage value by -1 then show the last li or page
            if (page < totalPages - 2 && totalPages > 5) {
                //if page value is less than totalPage value by -2 then add this (...) before the last li or page
                liTag += `<li class="page-item dots"><span class="page-link">...</span></li>`;
            }
            if (totalPages >= 5) {
                liTag += `<li class="page-item last numb"><button  data-page="${totalPages}" class="page-link"><span>${totalPages}</span></button></li>`;
            }
        }

        if (page <= totalPages) {
            //show the next button if the page value is less than totalPage
            if (page < totalPages) {
                liTag += `<li class="page-item" ><button data-page="${page +
                    1}" class="page-link" aria-label="Next"><span aria-hidden="true"></span></button></li>`;
            } else if (page == totalPages) {
                liTag += `<li class="page-item disabled"><button data-page="${page}" class="page-link" disabled="true" aria-label="Next"><span aria-hidden="true"></span></button></li>`;
            }
        }
        ui.$pagination.html(liTag); //add li tag inside ul tag
        $('.pagination .page-link').each(function() {
            $(this).on('click', paginationClick);
        });
    }

    function showLoader() {
        ui.$searchWrapper.css('opacity', '.3').css('pointer-events', 'none');
        ui.loader.show();
    }

    function hideLoader() {
        ui.$searchWrapper.css('opacity', '1').css('pointer-events', 'all');
        ui.loader.hide();
    }

    return {
        init: init,
    };
})(jQuery);

$(function() {
    Bunge.newsListings.init();
});
